"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCarouselView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const ArticleImage = app_1.styled.div `
  width: 100%;
  aspect-ratio: 1;
`;
const Wrap = (0, app_1.styled)(ui_1.Stack) `
  width: 100%;
  text-align: left;
`;
const InfoWrap = app_1.styled.div `
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
`;
function EventCarouselView({ events, className, }) {
    var _a;
    const eventPath = (_a = (0, app_1.useContextPath)('event')) !== null && _a !== void 0 ? _a : '/events';
    return ((0, jsx_runtime_1.jsxs)(Wrap, Object.assign({ className: className, kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "h2", as: "h4" }, { children: "Events" })), (0, jsx_runtime_1.jsx)(ui_1.CarouselKeen, { data: events, render: (data) => ((0, jsx_runtime_1.jsx)(app_1.AssetsProvider, Object.assign({ path: `${eventPath}/${data.id}` }, { children: (0, jsx_runtime_1.jsxs)(Wrap, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(ArticleImage, { children: (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: `${eventPath}/${data.slug}` }, { children: (0, jsx_runtime_1.jsx)(app_1.Image, { img: data.image }) })) }), (0, jsx_runtime_1.jsxs)(InfoWrap, { children: [data.category ? ((0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span", as: "sub-h4" }, { children: data.category.title }))) : null, (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: data.date ? new Date(data.date).toLocaleDateString() : null }))] }), (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span", as: "sub-h2" }, { children: data.title }))] })) }))), hideArrows: true, options: {
                    breakpoints: {
                        [app_1.notDesktop]: {
                            slides: {
                                perView: 1,
                            },
                        },
                    },
                    slides: {
                        perView: 'auto',
                        origin: 'center',
                        spacing: 45,
                    },
                } })] })));
}
exports.EventCarouselView = EventCarouselView;
